<div class="flex flex-col">
    <div class="flex">
        <span class="body-header" [translate]="header"></span>
        @if (text) {
            <app-tooltip [text]="text"></app-tooltip>
        }
    </div>
    @if (body) {
        <div class="body-copy">{{ body }}</div>
    }
    @if (htmlBody) {
        <div class="body-copy" [innerHTML]="htmlBody | translate"></div>
    }
</div>
